// Content for TOFT Gas, Heating & Plumbing website

export const businessInfo = {
  name: "TOFT Gas, Heating & Plumbing",
  shortName: "TOFT",
  tagline: "Gas · Heating · Plumbing",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_4a1cce61-ead5-4af2-a7d7-7a9257e4f31e/artifacts/wix768y5_WhatsApp%20Image%202026-06-19%20at%2014.04.44.jpeg",
  phone: "07885 592820",
  phoneInternational: "+447885592820",
  phoneTel: "tel:+447885592820",
  whatsapp: "https://wa.me/447885592820",
  sms: "sms:+447885592820",
  email: null,
  address: "Porth, Rhondda Cynon Taf",
  area: "Porth · South Wales",
  rating: 5.0,
  reviewCount: 5,
  hoursSummary: "Monday – Friday · Business Hours",
  emergencyNote: "Emergency Gas Callouts Available During Business Hours",
  facebook: "https://www.facebook.com/ToftPlumbingServicesLtd/",
  googleReviewLink: "https://g.page/r/",
  serviceAreas: [
    "Rhondda Cynon Taf",
    "Cardiff",
    "Bridgend",
    "Caerphilly",
  ],
  serviceTowns: [
    "Porth",
    "Pontypridd",
    "Tonypandy",
    "Treorchy",
    "Llantrisant",
    "Talbot Green",
    "Cardiff",
    "Bridgend",
    "Porthcawl",
    "Caerphilly",
  ],
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Boiler Services", to: "/boiler-services" },
  { label: "Landlord Services", to: "/landlord-services" },
  { label: "Gas & Heating", to: "/gas-heating" },
  { label: "Plumbing", to: "/plumbing-services" },
  { label: "Areas", to: "/areas-covered" },
  { label: "Reviews", to: "/reviews" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const homepageHero = {
  h1: "Boiler Servicing, Boiler Repairs & CP12 Certificates Across Cardiff, Pontypridd, Bridgend & Caerphilly",
  lead:
    "Looking for a reliable Gas Safe engineer who actually turns up when they say they will?",
  body: "Based in Porth, TOFT Gas, Heating & Plumbing provides boiler servicing, landlord gas safety certificates, boiler repairs, boiler installations and heating services across Rhondda Cynon Taf, Cardiff, Bridgend and Caerphilly — including Pontypridd, Tonypandy, Treorchy, Llantrisant, Talbot Green and Porthcawl.",
  trust: "Trusted by homeowners, landlords, HMO owners and property investors throughout South Wales.",
  priceLine:
    "Boiler Servicing From £70  ·  CP12 Certificates From £70  ·  Discounts Available When Booked Together",
};

export const trustPoints = [
  "Gas Safe Registered",
  "Boiler Servicing From £70",
  "CP12 Certificates From £70",
  "Fast CP12 Turnaround",
  "Business Hours Emergency Call Outs",
  "Call, Text & WhatsApp Available",
];

export const whyChoosePoints = [
  "Gas Safe Registered",
  "Honest Advice",
  "Reliable Appointments",
  "Friendly Service",
  "Trusted By Homeowners & Landlords",
  "Based In Porth",
  "Covering South Wales",
  "Easy Contact By Phone, WhatsApp & Text",
];

export const meetLee = {
  intro: "Hi, I'm Lee.",
  body: [
    "I'm the Gas Safe engineer behind TOFT Gas, Heating & Plumbing.",
    "Much of my work comes from repeat customers and recommendations, which I believe says everything about how a local business should operate.",
    "I believe in doing things properly, treating people fairly and providing the kind of service I'd want to receive myself.",
    "As a landlord myself, I understand the importance of compliance, reliability and keeping costs sensible.",
    "Whether you're a homeowner looking after your family home or a landlord managing multiple properties, you'll receive the same professional and reliable service every time.",
  ],
  goal:
    "Provide a service that customers feel confident recommending to friends, family and colleagues.",
};

export const homepageServices = [
  {
    id: "boiler",
    iconKey: "flame",
    title: "Boiler Servicing from £70",
    description:
      "Annual boiler servicing to help keep your heating system operating safely, efficiently and reliably across Cardiff, Pontypridd, Porth, Bridgend and Caerphilly.",
    href: "/boiler-services",
  },
  {
    id: "landlord",
    iconKey: "home",
    title: "CP12 Certificates from £70",
    description:
      "Fast landlord gas safety certificates for landlords, HMO owners and property investors across Rhondda Cynon Taf, Cardiff and South Wales.",
    href: "/landlord-services",
  },
  {
    id: "repair",
    iconKey: "wrench",
    title: "Boiler Repairs",
    description:
      "No heating? No hot water? We provide fault diagnosis and repairs across Cardiff, Pontypridd, Bridgend and Caerphilly.",
    href: "/boiler-services",
  },
  {
    id: "install",
    iconKey: "zap",
    title: "Boiler Installations",
    description:
      "Need a replacement boiler? Free quotations across South Wales — no pressure, no hard selling.",
    href: "/boiler-services",
  },
];

export const landlordServicesList = [
  "CP12 Gas Safety Certificates",
  "Boiler Servicing",
  "Boiler Repairs",
  "Boiler Replacements",
  "Rental Property Maintenance Support",
];

export const reviews = [
  {
    id: 1,
    name: "Steve",
    text: "What's great is that they are landlords themselves, so they know exactly what's needed. I can trust them to always be honest about what's needed and know that I am not getting ripped off.",
    rating: 5,
    role: "Landlord, Pontypridd",
  },
  {
    id: 2,
    name: "Sarah",
    text: "As reliable as you could ever want from a tradesman.",
    rating: 5,
    role: "Homeowner, Cardiff",
  },
  {
    id: 3,
    name: "Mark",
    text: "Professional, friendly and turned up exactly when promised.",
    rating: 5,
    role: "Homeowner, Porth",
  },
  {
    id: 4,
    name: "Rachel",
    text: "Excellent communication and quick turnaround.",
    rating: 5,
    role: "HMO Owner, Cardiff",
  },
  {
    id: 5,
    name: "Andrew",
    text: "Honest advice, fair pricing and quality workmanship.",
    rating: 5,
    role: "Property Investor, Bridgend",
  },
];

export const homepageFaqs = [
  {
    id: "h1",
    question: "How much does a boiler service cost?",
    answer:
      "Boiler servicing starts from £70 for most combi boilers. If you have additional gas appliances or a more complex heating system, the cost may vary slightly. Contact us for a quick quotation.",
  },
  {
    id: "h2",
    question: "How much is a Landlord Gas Safety Certificate?",
    answer:
      "Landlord Gas Safety Certificates (CP12s) start from £70. Discounts may be available when booked alongside a boiler service or for landlords with multiple properties.",
  },
  {
    id: "h3",
    question: "Do you offer emergency gas callouts?",
    answer:
      "Yes. We provide emergency gas callouts during normal business hours. If you suspect a gas leak or smell gas, immediately contact the National Gas Emergency Service on 0800 111 999 before contacting us.",
  },
];

export const fullFaqs = [
  {
    id: 1,
    question: "How much does a boiler service cost?",
    answer:
      "Boiler servicing starts from £70 for most combi boilers. If you have additional gas appliances or a more complex heating system, the cost may vary slightly. Contact us for a quick quotation.",
  },
  {
    id: 2,
    question: "How often should a boiler be serviced?",
    answer:
      "Most manufacturers recommend having your boiler serviced every 12 months. Regular servicing helps keep your boiler operating safely and efficiently, may reduce the risk of breakdowns and is often required to maintain manufacturer warranties.",
  },
  {
    id: 3,
    question: "How much is a Landlord Gas Safety Certificate?",
    answer:
      "Landlord Gas Safety Certificates (CP12s) start from £70. Discounts may be available when booked alongside a boiler service or for landlords with multiple properties.",
  },
  {
    id: 4,
    question: "What is a CP12 Certificate?",
    answer:
      "A CP12 Certificate, also known as a Landlord Gas Safety Certificate, confirms that gas appliances, flues and pipework within a rental property have been inspected by a Gas Safe registered engineer. Landlords are legally required to arrange these checks every 12 months.",
  },
  {
    id: 5,
    question: "Do you work with landlords?",
    answer:
      "Yes. We regularly work with landlords, HMO owners, property investors and letting agents throughout South Wales. Whether you own one rental property or a larger portfolio, we're happy to help.",
  },
  {
    id: 6,
    question: "Do you work with HMOs?",
    answer:
      "Yes. We regularly assist HMO owners with annual gas safety inspections, boiler servicing, repairs and ongoing maintenance support.",
  },
  {
    id: 7,
    question: "Do you offer emergency gas callouts?",
    answer:
      "Yes. We provide emergency gas callouts during normal business hours. If you suspect a gas leak or smell gas, immediately contact the National Gas Emergency Service on 0800 111 999 before contacting us.",
  },
  {
    id: 8,
    question: "Do you repair boilers?",
    answer:
      "Yes. We diagnose and repair many common boiler faults including no heating, no hot water, fault codes, low pressure, leaks and thermostat faults. If repairing your boiler isn't the most cost-effective option, we'll explain the alternatives clearly and honestly.",
  },
  {
    id: 9,
    question: "Do you install new boilers?",
    answer:
      "Yes. We provide free quotations for replacement boilers and will always recommend the most suitable option based on your property, heating requirements and budget. No pressure and no hard selling.",
  },
  {
    id: 10,
    question: "Do you fit smart thermostats?",
    answer:
      "Yes. We can install and advise on a range of heating controls and smart thermostats to help improve comfort and energy efficiency.",
  },
  {
    id: 11,
    question: "Do you install gas hobs and cookers?",
    answer:
      "Yes. We can install and connect domestic gas hobs and cookers safely and professionally.",
  },
  {
    id: 12,
    question: "Do you cover Cardiff?",
    answer: "Yes. We regularly work throughout Cardiff and the surrounding areas.",
  },
  {
    id: 13,
    question: "Do you cover Bridgend?",
    answer:
      "Yes. We regularly provide services throughout Bridgend, Porthcawl and surrounding locations.",
  },
  {
    id: 14,
    question: "Do you cover Caerphilly?",
    answer:
      "Yes. We provide boiler, gas, heating and plumbing services throughout Caerphilly and nearby areas.",
  },
  {
    id: 15,
    question: "Do you cover Rhondda Cynon Taf?",
    answer:
      "Yes. As a business based in Porth, Rhondda Cynon Taf is one of our core service areas.",
  },
  {
    id: 16,
    question: "Can I book by WhatsApp?",
    answer:
      "Absolutely. Many customers find WhatsApp the easiest way to get in touch. You can send messages, photos, fault codes and job details directly to us.",
  },
  {
    id: 17,
    question: "How do I book an appointment?",
    answer:
      "Simply call, WhatsApp or text us. We'll discuss your requirements and arrange a convenient appointment.",
  },
];

export const heroImage =
  "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=1800&q=85&auto=format&fit=crop";
export const leePortrait =
  "https://images.unsplash.com/photo-1581578017093-cd30fce4eeb7?w=900&q=85&auto=format&fit=crop";
export const boilerImage =
  "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1400&q=85&auto=format&fit=crop";
export const heatingImage =
  "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1400&q=85&auto=format&fit=crop";
export const plumbingImage =
  "https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=1400&q=85&auto=format&fit=crop";

export const pageHeroImages = {
  // home: modern luxury bathroom interior (verified)
  home: "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=1800&q=85&auto=format&fit=crop",
  // boiler: industrial gas pipework with "GAZ NATUREL" sign (verified - perfect for gas/boiler)
  boiler:
    "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=1800&q=85&auto=format&fit=crop",
  // landlord: model house + keys (verified - perfect)
  landlord:
    "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1800&q=85&auto=format&fit=crop",
  // gasHeating: industrial gas pipework (verified)
  gasHeating:
    "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=1800&q=85&auto=format&fit=crop",
  // plumbing: modern bathroom with freestanding tub (verified)
  plumbing:
    "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1800&q=85&auto=format&fit=crop",
  // areas: modern bathroom (used as a consistent brand image)
  areas:
    "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=1800&q=85&auto=format&fit=crop",
  // reviews: professional portrait of a customer (verified)
  reviews:
    "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?w=1800&q=85&auto=format&fit=crop",
  // faq: clean modern bathroom (fallback to brand image)
  faq: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1800&q=85&auto=format&fit=crop",
  // contact: hand signing a document (verified - perfect for contact/enquiry)
  contact:
    "https://images.unsplash.com/photo-1521791055366-0d553872125f?w=1800&q=85&auto=format&fit=crop",
};
